import React, { useEffect, useMemo, useRef, useState } from 'react';
import { answersTransformerRevert } from './transformer';
import { getPdfData } from './utils';
import AdobeTracking from './utils/AdobeTracking';
import Intro from './components/Intro';
import Section from './components/Section';
import Results from './components/Results';
import Cache from './service/Cache';
import InitialStagesData from './data/InitialStagesData';

function App() {
  const cache = useMemo(() => new Cache(), []);
  const [stage, setStage] = useState({
    key: 'intro'
  });
  const [recommendation, setRecommendation] = useState(null);
  const [stages, setStages] = useState(() => {
    const results = cache.get('results');

    if (null !== results) {
      return results.stages;
    }

    if ('results' !== stage.key) {
      const answers = getPdfData();
      if (answers) {
        if (answers.q1.length === 2) {
          setRecommendation('both');
        } else {
          setRecommendation(answers.q1[0]);
        }
        setStage({key: 'results', downloadOnly: true});
        return answersTransformerRevert(InitialStagesData, answers)
      }
    }
    return InitialStagesData;
  });
  let appHeight = 0;
  const appRef = useRef();
  const hasLoaded = useRef(false);

  const updateHeight = () => {
    appHeight = appRef?.current?.scrollHeight;

    window.parent.postMessage({
      name: 'height',
      height: appHeight
    }, "*");
  }

  // Update app height only when height has changed.
  useEffect(() => {
    setInterval(() => {
      if (appHeight === appRef?.current?.scrollHeight) return;

      updateHeight();
    }, 100);
  });

  useEffect(() => {
    if (hasLoaded.current) return;
    hasLoaded.current = true;

    const results = cache.get('results');
    if (null !== results) {
      setStage(stages[stages.length - 1]);
    }
  }, [stages, cache]);

  return <div id="app" ref={appRef}>
    <AdobeTracking />
    {'intro' === stage.key ? <Intro
      setStage={setStage}
      stages={stages}
      setRecommendation={setRecommendation}
    /> : ''}
    {!stage.key.includes('results') ? stages.filter(
      (stage) => !stage.key.includes('results')
    ).map((item, index) => stage.key === item.key ? <Section
      key={index}
      stage={stage}
      setStage={setStage}
      recommendation={recommendation}
      stages={stages}
      setStages={setStages}
    /> : '') : ''}
    {'results' === stage.key ? <Results
      stage={stage}
      setStage={setStage}
      stages={stages}
      recommendation={recommendation}
      setRecommendation={setRecommendation}
      downloadOnly={stage.downloadOnly}
    /> : ''}
  </div>;
}

export default App;
